import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEngagement = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 63.57215 63.5811",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Engagment" }), /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M39.51192,39.77983a23.15106,23.15106,0,0,1-16.91076,6.861,24.82247,24.82247,0,0,1-4.03941-.32314L7.545,52.08571a1.05238,1.05238,0,0,1-1.44812-1.36352L9.575,42.97842C4.5123,39.75458,1.25,34.69189,1.25,29.00593c0-9.74077,9.55607-17.63494,21.35116-17.63494a23.60939,23.60939,0,0,1,15.5559,5.55043",
		style: {
			stroke: "#FFFFFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	}), /* @__PURE__ */ _jsx("path", {
		d: "M60.20341,32.83581A39.72911,39.72911,0,0,1,47.108,45.61705,39.68646,39.68646,0,0,1,34.01735,32.83581c-2.53788-3.66422-3.466-11.157,1.049-14.46351C42.87818,13.58177,47.108,20.54763,47.108,20.54763s4.2298-6.96586,12.04645-2.17533C63.6646,21.67881,62.74128,29.17159,60.20341,32.83581Z",
		style: {
			stroke: "#FFFFFF",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2.5px"
		}
	})] })]
});
export default SvgEngagement;
